import "./Table.css"
var DeveloperPortalCompanySearchResults = function(props){
    return <div className="c_developerportal_companies_searchresults row">
        <div className="col-md-12">Name: {props.name}</div>
        <div className="col-md-6">Type: {props.type}</div>
        <div className="col-md-6">Region: {props.region}</div>
        <div className="col-md-6">Currency: {props.currency}</div>
        <div className="col-md-6">Symbol: {props.symbol}</div>
        <button className="c_developerportal_buttononwhite" onClick={props.addCompany.bind(null, {name: props.name, symbol: props.symbol})}>Add</button>
    </div>
}
export default DeveloperPortalCompanySearchResults